<template>
    <div>
        <v-stepper @change="setParameterCurrentStep" non-linear :value="parameterCurrentStep"
                   class="h-auto w-auto parameter-stepper">
            <v-stepper-header class="parameter-content">
                <v-stepper-step editable step="1">
                    <div class="text-white">
                        Personnalisation du formulaire
                    </div>
                </v-stepper-step>

                <v-stepper-step editable step="2">
                    <div class="text-white">
                        Informations administratives
                    </div>
                </v-stepper-step>

                <v-stepper-step editable step="3">
                    <div class="text-white">
                        E-mail de remerciement
                    </div>
                </v-stepper-step>

                <v-stepper-step editable step="4">
                    <div class="text-white">
                        Paramétrage avancé
                    </div>
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <personalize-form></personalize-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <administrative-datas></administrative-datas>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <cadh-email></cadh-email>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <advanced-parameters></advanced-parameters>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import QuestionTab from "./question/QuestionTab.vue"
import CadhConfigOffers from "./Offers.vue"
import AdministrativeDatas from "./parameterSteppers/AdministrativeDatas.vue"
import PersonalizeForm from "./parameterSteppers/PersonalizeForm.vue"
import CadhEmail from "./parameterSteppers/CadhEmail.vue"
import AdvancedParameters from "./parameterSteppers/AdvancedParameters.vue"

export default {
    name: "CadhConfigParameters",
    components: { AdvancedParameters, CadhConfigOffers, QuestionTab, AdministrativeDatas, PersonalizeForm, CadhEmail},
    data() {
        return {}
    },
    methods: {
        ...mapMutations("cadhConfig", ["setParameterCurrentStep"]),
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "parameterCurrentStep"]),
    },
    created() {

    },
}
</script>